module.exports = __webpack_public_path__ + "static/media/calendar.967794b7.svg";